import { type ReactElement } from 'react';

/** A drawn up / down / flat trend mark (16px, currentColor), shared by the figure strip and the KPI cards. */
export function TrendGlyph({ direction }: { direction: 'up' | 'down' | 'flat' }): ReactElement {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 16 16"
      className="h-3.5 w-3.5 shrink-0"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {direction === 'up' ? <path d="M3 11l4-4 2.5 2.5L13 6M9.5 6H13v3.5" /> : null}
      {direction === 'down' ? <path d="M3 5l4 4 2.5-2.5L13 10M9.5 10H13V6.5" /> : null}
      {direction === 'flat' ? <path d="M3 8h10M10 5l3 3-3 3" /> : null}
    </svg>
  );
}
